import React, { useState, useEffect, useCallback, useRef } from "react";
import { dmmSubdimensionsResults } from "../services/api-services";
import { toastEmitter } from "../utills/utilities";
import { API_RESPONSE } from "../utills/app-constant";
import SubDimensionCharts from "./subdimensionRadar";
import Modal from "../admin/components/common/Model";
import Remark from "../admin/components/Charts/Remark";
import { CHAT_ICON } from "../utills/image-constant";

const RadarChart = ({
  selectedCompanyId,
  selectedCampaignId,
  selectedDimensionId,
  type,
  graphName,
}) => {
  const [responseBody, setResponseBody] = useState([]);
  const [loading, setLoading] = useState(false);
  const [remark, setRemark] = useState("");
  const [remarkId, setRemarkId] = useState(null);
  const [isAttempt, setIsAttempt] = useState("");
  const [showRemarkModal, setShowRemarkModal] = useState(false);
  const modalRef = useRef(null);

  // ✅ Fetch Subdimension Radar Data
  const getSubdimensionData = useCallback(async () => {
    if (!selectedCompanyId) return;
    setLoading(true);
    try {
      const response = await dmmSubdimensionsResults(
        selectedCompanyId,
        selectedCampaignId,
        type,
        graphName
      );
      if (response?.data?.responseCode === 200) {
        let {
          responseBody,
          remark = "",
          remarkId = null,
          isAttempt = 0,
        } = response?.data;
        const filteredData = selectedDimensionId
          ? responseBody.filter(
              (item) =>
                String(item.dimensionId || item.id).trim() ===
                String(selectedDimensionId).trim()
            )
          : responseBody;

        setResponseBody(filteredData);
        if (selectedDimensionId) {
          responseBody = responseBody.filter(
            (item) =>
              String(item.dimensionId || item.id).trim() ===
              String(selectedDimensionId).trim()
          );
        }
        setResponseBody(responseBody || []);
        setRemark(remark);
        setRemarkId(remarkId);
        setIsAttempt(isAttempt);
      } else if (response?.data?.responseCode === 404) {
        setResponseBody([]);
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    } finally {
      setLoading(false);
    }
  }, [
    selectedCompanyId,
    selectedCampaignId,
    selectedDimensionId,
    type,
    graphName,
  ]);

  useEffect(() => {
    getSubdimensionData();
  }, [getSubdimensionData]);

  return (
    <div className="card p-2">
      <h5 className="fw-bold mb-3">Subdimension Radar Charts</h5>

      {loading ? (
        <div className="text-center my-5">
          <div className="spinner-border text-primary" role="status"></div>
        </div>
      ) : responseBody.length > 0 ? (
        <>
          {/*  Each subdimension with Zoom + Menu */}
          <SubDimensionCharts responseBody={responseBody} />

          {/* Single Remark Button below all charts */}
          <div className="d-flex justify-content-end mt-2">
            <button
              title="Add Comment"
              onClick={() => {
                setShowRemarkModal(true);
                setTimeout(() => {
                  if (modalRef.current) modalRef.current.click();
                }, 0);
              }}
              className="border-0 bg-transparent d-flex align-items-center gap-1"
            >
              <img src={CHAT_ICON} alt="chat" />
            </button>
          </div>

          {/*  Remark Modal */}
          {showRemarkModal && (
            <Modal modalClick={modalRef} title="Remark" buttonLable="">
              <Remark
                selectedCompanyId={selectedCompanyId}
                selectedCampaignId={selectedCampaignId}
                type={type}
                graphName={graphName}
                initialRemark={remark}
                remarkId={remarkId}
                isAttempt={isAttempt}
                setRemarkprops={setRemark}
                setRemarkIdProps={setRemarkId}
                onCloseModal={() => setShowRemarkModal(false)}
              />
            </Modal>
          )}
        </>
      ) : (
        <p className="text-center text-muted mt-3">
          No radar data available to display.
        </p>
      )}
    </div>
  );
};

export default RadarChart;
